import React from 'react';
import { ReactComponent as AuditSvg } from 'components/Campaigns/CreateEdit/Objective/assets/audit.svg';
import { ReactComponent as InStoreDemoSvg } from 'components/Campaigns/CreateEdit/Objective/assets/instore-demo.svg';
import { ReactComponent as InStorePromotionSvg } from 'components/Campaigns/CreateEdit/Objective/assets/instore-promotion.svg';
import { ReactComponent as NewProductSvg } from 'components/Campaigns/CreateEdit/Objective/assets/new-product.svg';
import { ReactComponent as PlacementSvg } from 'components/Campaigns/CreateEdit/Objective/assets/placement.svg';
import { ReactComponent as PricingComplianceSvg } from 'components/Campaigns/CreateEdit/Objective/assets/pricing-compliance.svg';
import {
  CampaignObjectiveKey,
  CampaignObjectiveKeyLabel,
  CampaignObjectiveKeyType
} from 'utils/types';
import 'components/Campaigns/CreateEdit/Objective/styles.scss';

interface Props {
  selected?: boolean;
  type: CampaignObjectiveKeyType;
  onClick(type: CampaignObjectiveKeyType): void;
}

const ICONS = Object.freeze({
  [CampaignObjectiveKey.AUDIT]: <AuditSvg />,
  [CampaignObjectiveKey.IN_STORE_DEMO]: <InStoreDemoSvg />,
  [CampaignObjectiveKey.IN_STORE_PROMOTION]: <InStorePromotionSvg />,
  [CampaignObjectiveKey.NEW_PRODUCT_INTRO]: <NewProductSvg />,
  [CampaignObjectiveKey.PLACEMENT]: <PlacementSvg />,
  [CampaignObjectiveKey.PRICING_COMPLIANCE]: <PricingComplianceSvg />
});

const CampaignObjective: React.FC<Props> = ({ selected = false, type, onClick }) => (
  <div
    className={`campaign-objective${selected ? ' selected' : ''}`}
    onClick={() => !selected && onClick(type)}
  >
    <div className={`icon${selected ? ' selected' : ''}`}>{ICONS[type]}</div>
    <div className={`co-title${selected ? ' selected' : ''}`}>
      {CampaignObjectiveKeyLabel[type].toUpperCase()}
    </div>
  </div>
);

export default CampaignObjective;
